import React from 'react';
import { Card } from './Card';
import { cn } from '../../utils/cn';

interface ToggleStatCardProps {
  active: boolean;
  onToggle: () => void;
  label: string;
  /** Full ring class so Tailwind picks it up, e.g. 'ring-danger-500' */
  activeRingClass?: string;
  className?: string;
  children: React.ReactNode;
}

export function ToggleStatCard({
  active,
  onToggle,
  label,
  activeRingClass = 'ring-primary-500',
  className,
  children,
}: ToggleStatCardProps) {
  return (
    <Card
      role="button"
      tabIndex={0}
      aria-pressed={active}
      aria-label={label}
      onClick={onToggle}
      onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onToggle();
        }
      }}
      className={cn(
        'cursor-pointer transition-all duration-200 hover:shadow-elevation-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500',
        active && `ring-2 ${activeRingClass}`,
        className
      )}
    >
      {children}
    </Card>
  );
}
